<template>
  <div>
    <a-modal
      title="课程方详情"
      :maskClosable="false"
      :width="800"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :cancelText="'取消'"
      :okText="'确定'"
      @cancel="handleCancel"
      :footer=null
    >
    <ul class="institution-info">
      <li>
        <span class="key">课程方名称：</span>
        <span class="value">{{institution.institutionName}}</span>
      </li>
      <li>
        <span class="key">课程方类型：</span>
        <span class="value">{{institution.classifyName}}</span>
      </li>
      <li>
        <span class="key">教育局：</span>
        <span class="value">{{institution.bureauName}}</span>
      </li>
      <li>
        <span class="key">保证金：</span>
        <span class="value">{{institution.bailAmount}}</span>
      </li>
      <li v-if="institution.province || institution.city || institution.district">
        <span class="key">地区：</span>
        <span class="value">{{institution.province}}{{institution.city}}{{institution.district}}</span>
      </li>
      <li v-if="institution.address">
        <span class="key">详细地址：</span>
        <span class="value">{{institution.address}}</span>
      </li>
      <li v-if="institution.masterName">
        <span class="key">执行校长姓名：</span>
        <span class="value">{{institution.masterName}}</span>
      </li>
      <li v-if="institution.masterMobile">
        <span class="key">执行校长手机号：</span>
        <span class="value">{{institution.masterMobile}}</span>
      </li>
      <li v-if="institution.certificateUrl" class="hover-font-active" @click="showIamge = institution.certificateUrl">
        <span class="key">营业执照：</span>
        <span class="value"><img :src="institution.certificateUrl"></span>
      </li>
      <li v-if="institution.cardFrontUrl" class="hover-font-active" @click="showIamge = institution.cardFrontUrl">
        <span class="key">身份证正面照片：</span>
        <span class="value"><img :src="institution.cardFrontUrl"></span>
      </li>
      <li v-if="institution.cardBackUrl" class="hover-font-active" @click="showIamge = institution.cardBackUrl">
        <span class="key">身份证背面照片：</span>
        <span class="value"><img :src="institution.cardBackUrl"></span>
      </li>
      <li v-if="institution.bailUrl" class="hover-font-active" @click="showIamge = institution.bailUrl">
        <span class="key">打款凭证：</span>
        <span class="value"><img :src="institution.bailUrl"></span>
      </li>
      <li v-if="institution.licenceUrl" class="hover-font-active" @click="showIamge = institution.licenceUrl">
        <span class="key">办学许可证：</span>
        <span class="value"><img :src="institution.licenceUrl"></span>
      </li>
      <li v-if="institution.statusText">
        <span class="key">审核状态：</span>
        <span class="value">{{institution.statusText}}</span>
      </li>
      <li v-if="institution.failReason && institution.status == '4'">
        <span class="key">不通过理由：</span>
        <span class="value">{{institution.failReason}}</span>
      </li>
    </ul>

    <!-- 只有教育局才能审核 -->
    <div class="institution-check" v-if="userInfo && userInfo.accRole.id == '2' && institution.status == 2">
      <a-button type="primary" @click="check('3')" style="margin-right: 20px">审核通过</a-button>
      <a-button type="primary" @click="isNoPass = true">审核不通过</a-button>
      <div v-if="isNoPass" class="check-confirm">
        <a-textarea
          placeholder="请输入审核不通过理由"
          :autosize="{ minRows: 2, maxRows: 6 }"
          v-model="failReason"
        />
        <a-button type="primary" @click="check('4')">确定</a-button>
      </div>
    </div>
    </a-modal>
    <div class="show-image-outer" v-if="showIamge" @click="showIamge = ''">
      <div class="show-image-bg"></div>
      <img :src="showIamge">
    </div>
  </div>
</template>

<script>
import institution from '../../api/institution'

export default {
  name: "institutionFormModal",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      institution: {},
      userInfo: null,

      isNoPass: false, //展示审核不通过输入框
      failReason: '', //审核失败原因
      showIamge: '',
    };
  },
  methods: {
    // showIamge(value){
    //   let imageOuter = document.createElement('div')
    //   imageOuter.style.position = 'fixed';
    //   imageOuter.style.top = '0px';
    //   imageOuter.style.left = '0px';
    //   imageOuter.style.width = '100vw';
    //   imageOuter.style.height = '100vh';
    //   imageOuter.style.background = 'red';
    //   imageOuter.style.zIndex = '10000';
    //   document.body.appendChild(imageOuter)
    // },
    //初始化，显示
    init(detail) {
      this.visible = true;
      this.isNoPass = false;
      this.failReason = '';
      this.institution = detail;
    },

    //审核
    check(status){
      let req = {
        status: status,
        failReason: this.failReason,
      }
      institution.check(this.institution.id,req).then(res=>{
        this.$message.success('审核成功')
        this.handleCancel();
        this.$emit('updateData',res.data)
      })
    },

    //隐藏
    handleCancel() {
      this.visible = false;
      this.$emit("closeForm");
    },

  },
  created() {
    this.$store.dispatch('getUserInfo').then(res=>{
      this.userInfo = res;
      console.log()
    })
  }
};
</script>
<style lang="scss" scoped>
@import "src/config/var";

.institution-info{
  text-align: left;
  height: calc(100vh - 320px);
  overflow-y: auto;
  overflow-x: hidden;
  li{
    font-size: 16px;
    line-height: 40px;
    padding: 6px 0px;
    .key{
      display: inline-block;
      font-weight: 600px;
      color: $normal-color-light;
      width: 130px;
      text-align: right;
    }
    .value{
      color: $normal-color-dark;
      padding-left: 6px;
      display: inline-block;
      padding-right: 16px;
      text-align: left;
      img{
        width: 100px;
        height: 100px;
        vertical-align: top;
        position: relative;
        top: 10px;
        
      }
    }
    .oper{
      color: $primary-color-dark;
      cursor: pointer;
    }
    .intro{
      width: 100%;
      padding: 0px 20px;
      display: inline-block;
      color: $normal-color-dark;
    }
  }
  .update-oper{
    text-align: center;
  }
}
.institution-check{
  padding-top: 10px;
  border-top: 1px solid $border-color;
  margin-top: 16px;
  text-align: center;
}
.check-confirm{
  margin-top: 16px;
  textarea{
    width: 300px;
    margin-left: 376px;
    vertical-align: middle;
    margin-right: 8px;
  }
}
.show-image-outer{
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 999999;
  .show-image-bg{
    width: 100%;
    height: 100vh;
    background: black;
    opacity: .5;
    z-index: 1000000;
    cursor: pointer;
  }
  img{
    cursor: pointer;
    position: fixed;
    top: 10vh;
    height: 80vh;
    margin-left: 50%;
    transform: translateX(-50%);
    z-index: 1000001;
    text-align: center;
  }
}
</style>